import React from 'react';
import { autobind } from 'core-decorators';
import Layout from '../components/Layout/LayoutIndex';
import { getHtmlTDK } from '../../../lib/utils/UtilsCommon';
import './SincerityCompliance.less';

/**
 * state
 */
interface IState {
	htmlTDK: {
		title: string;
	};
}

/**
 * 诚信合规页面
 *
 * @class SincerityCompliance
 * @extends {React.Component<any>}
 */
@autobind
class SincerityCompliance extends React.Component<any, any> {
	constructor(props: any, context?: any) {
		super(props, context);

		/**
		 * 静态化渲染数据放这里处理
		 */

		let { initData } = props;
		const state: any = {
			htmlTDK: {
				title: '兴趣岛诚信合规——名师更多，课程更全',
				pageDescription:
					'兴趣岛兴趣学堂-名师更多，课程更全。摄影、瑜伽等30门主流课程21门学员数量全国领先。',
				pageKeyword:
					'兴趣,兴趣岛,兴趣岛兴趣学堂,兴趣学堂,千聊兴趣岛,兴趣岛-名师更多，课程更全,兴趣岛兴趣学堂-名师更多，课程更全,千聊,知识付费,内容付费,千聊特训营,成人教育',
			},
		};

		this.state = state;
	}

	/**
	 * 动态渲染数据放这里处理
	 *
	 * @static
	 * @param {*} { req }
	 * @returns {Promise<any>}
	 * @memberof HomeTraining
	 */
	public static async getInitialProps(context: any): Promise<any> {
		console.log('诚信合规');

		return {};
	}

	componentDidMount(): void {
		this.setState({
			host: location.host,
		});
	}

	/**
	 * 渲染页面
	 *
	 * @returns {*}
	 * @memberof HomeTraining
	 */
	public render(): any {
		const { htmlTDK, host } = this.state;

		return (
			<Layout
				{...getHtmlTDK(htmlTDK)}
				bodyClass="sincerity-compliance-page"
				activeTab="sincerityCompliance"
			>
				<div
					className="main-container"
					style={{
						background:
							'url(https://img.qlchat.com/qlLive/activity/image/CL7R4UK3-L7SO-7X28-1740034107012-GUH9EUFGS88T.png?x-oss-process=image/format,webp) center/100% 100% no-repeat',
					}}
				>
					<div className="main-container-width">
						<div className="column-title">
							<img
								className="column-title-img"
								src="https://img.qlchat.com/qlLive/activity/image/7HJ3IA7T-4OVR-MLSC-1740034432528-QUCYRBAJIWSC.png"
							/>
						</div>
						<div className="main-container-content">
							<div className="main-container-line-horizontal"></div>
							<div className="main-container-line-vertical"></div>
							<div className="content-flex">
								<div className="content-item">
									<p className="content-item-title">受理范围</p>
									<p className="content-item-dsc">
										兴趣岛员工或合作方违规违法行为的举报。
									</p>
								</div>
								<div className="content-item">
									<p className="content-item-title">举报须知</p>
									<p className="content-item-dsc">
										鼓励实名举报，举报内容应客观公正，不捏造、歪曲事实，不陷害他人。
									</p>
								</div>
							</div>
							<div className="content-flex">
								<div className="content-item">
									<p className="content-item-title">举报保护</p>
									<p className="content-item-dsc">
										我们承诺对举报内容、举报人身份、证据等资料严格保密，严禁打击报复。
									</p>
								</div>
								<div className="content-item">
									<p className="content-item-title">举报奖励</p>
									<p className="content-item-dsc">
										举报事项一经查实，提供有效线索或挽回损失的，给予表彰或奖励。
									</p>
								</div>
							</div>

							<div className="content-bottom">
								<div className="content-bottom-item">
									举报邮箱：jiancha@qlchat.com
								</div>
								<div className="content-bottom-item">
									举报地址：广州市天河区奥体南路9号兴趣岛办公大楼 审计监察组收
								</div>
							</div>
						</div>
					</div>
				</div>
			</Layout>
		);
	}
}

export default SincerityCompliance;
